<template>
    <div class="chat-message__audio chat-message__content" :id="message.id">
        <div class="chat-message__audio-top">
            <audio controls :src="src" ref="audio"
                style="width: 100%;"
                @play="isPlaying = true"
                @pause="isPlaying = false"
                v-show="false"
            ></audio>
            <button class="button chat-message__audio-button button_type_icon" @click="togglePlay">
                <svg v-if="!isPlaying" aria-hidden="true" width="24" height="24" >
                    <use href="#icon-play"></use>
                </svg>
                <svg v-else aria-hidden="true" width="24" height="24" >
                    <use href="#icon-paused"></use>
                </svg>
            </button>
            <div  ref="progressBar" class="chat-message__audio-progress" @click="seekAudio($event)"  @mousedown="startDrag">
                <!-- <pre>{{ bars  }}</pre> -->
                <!-- <div
                v-for="(h, i) in bars"
                :key="i"
                class="bar"
                :class="{ active: i <= currentBarIndex }"
                :style="{ 
                    minHeight: h + '%',
                }"
                ></div> -->

                <div class="bar bar_fake" v-for="(v, i) in new Array(22)" :key="i"
                :class="{ active: i <= currentBarIndex }"
                ></div>

            </div>
            <div class="chat-message__audio-timer">
                <template v-if="isDirty">
                    {{ formatTime(currentTime) }} 
                </template>
                <template v-else>
                    {{ formatTime(duration) }} 
                </template>
            </div>
            <div style="position: relative;">
                <button class="button chat-message__audio-button chat-message__audio-button_vol button_type_icon" :disabled="!isready"
                    :class="{ 'chat-message__audio-button_vol-active': showVolSlider }"
                    @click="togglerVolSlider"
                >
                    <svg aria-hidden="true" width="24" height="24" v-if="volume >= 70" >
                        <use href="#icon-volume-max"></use>
                    </svg>
                    <svg aria-hidden="true" width="24" height="24" v-else-if="volume >= 30" >
                        <use href="#icon-volume-half"></use>
                    </svg>
                    <svg aria-hidden="true" width="24" height="24" v-else-if="volume >= 0" >
                        <use href="#icon-volume-low"></use>
                    </svg>
                </button>
                <div class="chat-message__volume" v-show="showVolSlider" ref="volumeSlider">
                    <v-slider 
                        v-model="volume"
                        :min="0"
                        :max="100"
                        :step="1"
                        :showTicks="false"
                        :tickCount="5"
                        class="--small --minimal "
                        @input="handleChangeVolume"
                    />
                </div>
            </div>

            <v-button v-if="!transcription" class="chat-message__audio-button button_type_icon" 
                @click="handleClickcTranscription"
                :loading="transcriptionBizzy"
                :disabled="transcriptionBizzy"
            >
                <svg aria-hidden="true" width="24" height="24" v-if="!transcriptionBizzy" >
                    <use href="#icon-eye"></use>
                </svg>
            </v-button>
            
        </div>
        <div class="chat-message__footer">
            <svg v-if="message.is_send && message.is_read " aria-hidden="true" width="12" height="12">
                <use href="#icon-double-check"></use>
            </svg>
            <svg v-else-if="message.is_send || message.is_read " aria-hidden="true" width="12" height="12">
                <use href="#icon-checked"></use>
            </svg>
            {{message.date_created}}
        </div>

        <div v-if="transcription">
            <span v-html="transcription"></span>
        </div>
    </div>
</template>

<script>
import api from '@api'
import vSlider from '@components/global/vSlider'
import vButton from '@components/global/vButton.vue';

export default {
    props: {
        message: {
            type: Object,
            default: () => {}
        },
        id: {
            type: Number,
            default: null
        }
    },
    components: {
        vSlider,
        vButton
    },
    data() {
        return {
            volume: 0,
            currentTime: 0,
            duration: 0,
            animationId: null,
            isPlaying: false,
            bars: [],
            currentBarIndex: -1,
            isDirty: false,
            showVolSlider: false,
            timerVolSlider: null,
            src: '',
            isready: false,
            transcription: '',
            transcriptionBizzy: false
        }
    },
    mounted() {
        this.src = this.message.message

        //this.generateWaveform(this.src)
        const audio = this.$refs.audio
        audio.src = this.src;       // задаём URL
        audio.preload = "auto";     // загружать полностью
        audio.load();  

        audio.addEventListener('loadedmetadata', () => {
            this.duration = audio.duration
            this.volume = audio.volume * 100
        })

        const volumeSlider = this.$refs.volumeSlider
        volumeSlider.addEventListener('mouseleave', () => {
            this.startTimerToHideVolSlider()    
        })

        audio.addEventListener("loadedmetadata", () => {
            ///console.log("Длительность:", audio.duration);
            
        });

        audio.addEventListener("canplaythrough", () => {
            this.isready = true
        });

    },
    methods: {
        startTimerToHideVolSlider() {
            if(this.timerVolSlider) clearTimeout(this.timerVolSlider)
            this.timerVolSlider = setTimeout(() => {
                
                this.showVolSlider = false
                clearTimeout(this.timerVolSlider)
            },3000)
        },
        togglerVolSlider() {
            this.showVolSlider = !this.showVolSlider
            this.startTimerToHideVolSlider()
        },
        togglePlay() {
            const audio = this.$refs.audio
            this.$emit('togglePlay', this.id)
            if (audio.paused) {
                this.isDirty = true
                audio.play()
                this.isPlaying = true
                this.startBarHighlight()
                this.startProgress()
            } else {
                audio.pause()
                this.isPlaying = false
                cancelAnimationFrame(this.animationId)
            }
        },
        furceStopPlay(id) {
            const audio = this.$refs.audio
            audio.pause()
            this.isPlaying = false
            cancelAnimationFrame(this.animationId)
        },
        
        startBarHighlight() {
            const audio = this.$refs.audio
            
            const update = () => {
                const progress = audio.currentTime / audio.duration
                this.currentBarIndex = Math.floor(progress * 22)
                this.animationId = requestAnimationFrame(update)
            }
            
            update()
        },
        async generateWaveform(url) {
            const response = await fetch(url)
            const arrayBuffer = await response.arrayBuffer()

            const audioCtx = new (window.AudioContext || window.webkitAudioContext)()
            const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer)
            
            // Берём один канал (левый)
            const rawData = audioBuffer.getChannelData(0)
            
            // Количество полосок
            const samples = 22
            const blockSize = Math.floor(rawData.length / samples)
            
            const bars = []
            
            for (let i = 0; i < samples; i++) {
                let blockStart = i * blockSize
                let sum = 0
                
                // RMS — средняя мощность блока
                for (let j = 0; j < blockSize; j++) {
                    sum += Math.abs(rawData[blockStart + j])
                }
                
                let avg = sum / blockSize
                
                bars.push(avg * 200)
            }
            
            this.bars = this.normolize(bars) // нормализуем bars
            
            // this.bars = bars
        },
        
        normolize(bars) {
            const MIN = 1
            const MAX = 100
            const maxValue = Math.max(...bars)
            const minValue = Math.min(...bars)
            
            return bars.map(v => {
                // нормализуем 0–1
                const norm = (v - minValue) / (maxValue - minValue || 1)
                // растягиваем в диапазон MIN–MAX
                return norm * (MAX - MIN) + MIN
            })
        },
        
        beforeDestroy() {
            cancelAnimationFrame(this.animationId);
        },
        
        seekAudio(event) {
            
            this.isDirty = true
            const audio = this.$refs.audio
            const progressBar = this.$refs.progressBar
            
            const rect = progressBar.getBoundingClientRect()
            const clickX = event.clientX - rect.left
            const fraction = clickX / rect.width
            
            // если duration ещё 0, возьмём сохранённое
            const dur = this.duration || audio.duration || 0
            
            audio.currentTime = fraction * dur
            this.currentTime = audio.currentTime  // обновляем сразу таймер
            
            this.currentBarIndex = Math.floor(fraction *  22)
            
        },
        startDrag() {
            this.isDirty = true
            window.addEventListener('mousemove', this.onDrag)
            window.addEventListener('mouseup', this.stopDrag)
        },
        onDrag(event) {
            this.seekAudio(event)
        },
        stopDrag() {
            window.removeEventListener('mousemove', this.onDrag)
            window.removeEventListener('mouseup', this.stopDrag)
        },
        startProgress() {
            const audio = this.$refs.audio
            const update = () => {
                this.currentTime = audio.currentTime
                const progressFraction = audio.currentTime / audio.duration
                this.currentBarIndex = Math.floor(progressFraction * 22)
                this.animationId = requestAnimationFrame(update)
            }
            update()
        },
        formatTime(time) {
            if (!time) return '0:00'
            const minutes = Math.floor(time / 60)
            const seconds = Math.floor(time % 60)
            return `${minutes}:${seconds.toString().padStart(2,'0')}`
        },

        handleChangeVolume(value) {
            if(this.$refs.audio) {
                this.$refs.audio.volume = value / 100
                this.volume = value
            }
        },
        handleClickcTranscription() {
            this.transcriptionBizzy = true
            api.chat.speechToText({id:this.id},'','post').then((res) => {
                this.transcription = res.response.text
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.transcriptionBizzy = false
            })
        }
    },
}
</script>

